<template lang="pug">
validation-observer(ref='validation' tag='form')
    el-card(
      v-if="active != null"
    )
      el-row
        app-opcoes-header-analise.right(
          :idProcesso="idProcesso",
          :protocolo="processo.protocolo"
          :numeroProcesso="processo.numeroProcesso",
          :tipoProcesso="processo.tipo.codigo",
          :btnSolicitarInformacao="false"
          :btnRetificacao="false"
          :btnNotificarInteressado="false"
        )
      el-row
        div(v-if="!this.visualizarCertidao")
          el-steps.margin-top(:active='active', finish-status='success', simple)
            el-step(title='Informar dados')
            el-step(title='Confirmar dados')
      div(v-if="active === 0")
        app-divider.margin-medium-top(
          :label="'01 - CARACTERÍSTICAS DO TÍTULO'",
          :showBorder="false",
        )
        el-row.margin-medium-top(:gutter="20")
          el-col(:span="8")
            app-label(
                label="Nº do título: ",
                :required="true"
              )
            el-input.input(
              v-model='infoCertidao.certidao.titulo.numero',
              :disabled="true"
            )
          el-col(:span="8")
            validation-provider(rules="required", v-slot="{ errors }")
              app-label(
                label="Data de Emissão:",
                :required="true"
              )
              el-date-picker.input.full-width(
                name="data",
                v-model='infoCertidao.certidao.titulo.dataEmissao',
                type='month',
                placeholder='Selecione',
                v-bind="$attrs",
                format="DD/MM/yyyy",
                :disabled="true"
              )
          el-col(:span="8")
            validation-provider(rules="required", v-slot="{ errors }")
              app-label(
                label="Processo Administrativo:",
                :required="true"
              )
              el-input.input(
                v-model="infoCertidao.certidao.titulo.numeroProcesso",
                name='numeroProcesso',
                :disabled="true"
              )

        el-row.margin-medium-top(:gutter="20")
          el-col(:span="6")
            app-label(
                label="Presidente: ",
                :required="true"
              )
            el-input.input(
              v-model='infoCertidao.certidao.presidente',
              :disabled="true"
            )
          el-col(:span="6")
            validation-provider(rules="required", v-slot="{ errors }")
              app-label(
                label="CPAV:",
                :required="true"
              )
              el-input.input(
                v-model='infoCertidao.certidao.cpav',
                :disabled="true"
              )
          el-col(:span="6")
            validation-provider(rules="required", v-slot="{ errors }")
              app-label(
                label="FL:",
                :required="true"
              )
              el-input.input(
                v-model="infoCertidao.certidao.fl",
                name='fl',
                :disabled="false"
              )
          el-col(:span="6")
            validation-provider(rules="required", v-slot="{ errors }")
              app-label(
                label="Forma Pagamento:",
                :required="true"
              )
              el-input.input(
                v-model="infoCertidao.certidao.formaPagamento ||'--'",
                name='formaPagamento',
                :disabled="true"
              )

        el-row.margin-medium-top(:gutter="20")
          app-divider.margin-medium-top(
            :label="'02 - OUTORGADO'",
            :showBorder="false",
          )
        el-row.margin-medium-top(:gutter="20")
          el-col(:span="24")
            validation-provider(rules="required", v-slot="{ errors }")
                app-label(
                  label="Nome do Outorgado: ",
                  :required="true"
                )
                el-input.input(
                  v-model="infoCertidao.certidao.outorgados[0].nome || '--'",
                  name='nome',
                  :disabled="true"
                )
        el-row.margin-medium-top(:gutter="20")
          el-col(:span="6")
            validation-provider(rules="required", v-slot="{ errors }")
              app-label(
                label="Nº do RG:",
                :required="true"
              )
              el-input.input(
                v-model="infoCertidao.certidao.outorgados[0].rg",
                name='rg',
                :disabled="true"
              )

          el-col(:span="6")
            validation-provider(rules="required", v-slot="{ errors }")
              app-label(
                label="Orgão Expedidor:",
                :required="true"
              )
              el-input.input(
                v-model="infoCertidao.certidao.outorgados[0].orgaoExpedidor",
                name='orgaoExpedidor'
              )

          el-col(:span="6")
            validation-provider(rules="required", v-slot="{ errors }")
              app-label(
                label="UF do RG:",
                :required="true"
              )
              el-input.input(
                v-model="infoCertidao.certidao.outorgados[0].uf",
                name='uf'
              )

          el-col(:span="6")
            validation-provider(rules="required", v-slot="{ errors }")
              app-label(
                label="CPF/CNPJ:",
                :required="true"
              )
              el-input.input(
                v-model="infoCertidao.certidao.outorgados[0].cpfCnpj || '--'",
                name='cpfCnpj',
                :disabled="true"
              )

        el-row.margin-medium-top(:gutter="20" v-if="processo.tipo.codigo !== 'CERTICADAO_TITULO' && infoCertidao.imovel")
          app-divider.margin-medium-top(
            :label="'03 - CARACTERÍSTICAS DO IMÓVEL'",
            :showBorder="false",
          )
        el-row.margin-medium-top(:gutter="20" v-if="processo.tipo.codigo !== 'CERTICADAO_TITULO' && infoCertidao.imovel")
          el-col(:span="6")
              app-label(
                label="Município:",
                :required="true"
              )
              el-input.input(
                v-model="infoCertidao.certidao.imovel.municipios[0].nome",
                name='municipio',
                :disabled="true"
              )
          el-col(:span="6")
            app-label(
              label="UF: ",
              :required="true"
            )
            el-input.input(
              v-model="infoCertidao.certidao.imovel.municipios[0].codigoEstado",
              name='codigoEstado',
              :disabled="true"
            )
          el-col(:span="6" v-if="processo.tipo.codigo !== 'CERTICADAO_TITULO' && infoCertidao.imovel")
            validation-provider(rules="required", v-slot="{ errors }")
              app-label(
                label="Denominação do Imóvel: "
              )
              el-input.input(
                v-model="infoCertidao.certidao.imovel.denominacao",
                name='denominacao',
                :disabled="true"
              )
        el-row.margin-medium-top(:gutter="20" v-if="processo.tipo.codigo !== 'CERTICADAO_TITULO' && infoCertidao.imovel")
          el-col(:span="6")
              app-label(
                label="Perímetro (m):",
                :required="true"
              )
              app-double-input.input(
                v-model="infoCertidao.certidao.imovel.perimetro",
                name='perimetro',
                :precision="2",
                :disable="true"
              )
          el-col(:span="6")
              app-label(
                label="Área (m²):",
                :required="true"
              )
              app-double-input.input(
                v-model="infoCertidao.certidao.imovel.area",
                name='area',
                :precision="4",
                :disable="true"
              )
        el-row.margin-medium-top(:gutter="20")
          app-divider.margin-medium-top(
            :label="processo.tipo.codigo !== 'CERTICADAO_TITULO' && infoCertidao.imovel ? '04 - DADOS DO PAGAMENTO' : '03 - DADOS DO PAGAMENTO'",
            :showBorder="false",
          )

        el-row.margin-medium-top(:gutter="20")
          el-col(:span="24")
            el-table(
              :data="infoCertidao.certidao.pagamentos",
            )
              template(slot="empty")
                | Nenhum pagamento cadastrado.
              el-table-column(
                prop="descricao",
                label="Descrição",
              )
              el-table-column(
                prop="numero",
                label="Número",
              )
              el-table-column(
                prop="valor",
                label="Valor"
                :formatter="formatValor"
              )
              el-table-column(
                prop="dataPagamento",
                label="Data do Pagamento"
                :formatter="formatDate"
              )
              el-table-column(
                label="Banco"
              )
                template(slot-scope='scope')
                  el-input.input(
                    v-model="scope.row.banco"
                  )

        el-row
          div.buttons-memorial
            el-button.btn(
              type="default"
              @click="cancelar"
            )
              i.fa.fa-times
              | &nbsp Cancelar
            el-button.btn(
              type="success",
              @click="proximo"
            )
              i.fa.fa-chevron-right
              | &nbsp Próximo
      div(v-else)
        div
          div.container(v-if="this.bytes != null")
            h2 Certidão de Quitação
            app-pdf-viewer(:bytes="bytes",nomeDocumento="Certidão de Quitação.pdf")
            div.flex-center
              el-button(
                size="small",
                type="success",
                @click="downloadPdf",
              )
                i.fal.fa-file-pdf
                span &nbsp Exportar PDF
        div.buttons-memorial
          .float-left
            el-button.btn(
              type="default"
              @click="voltar"
              v-if="!this.visualizarCertidao"
            )
              i.fa.fa-chevron-left
              | &nbsp Voltar
            el-button.btn(
              type="default"
              @click="cancelar"
              v-if="!this.visualizarCertidao"
            )
              i.fa.fa-times
              | &nbsp Cancelar
          .float-right
            el-button.btn(
              type="success",
              @click="finalizarPortaria"
            )
              i.fa.fa-check
              | &nbsp Finalizar
</template>

<script>

import { mapActions } from 'vuex'
import AppDivider from '@/components/AppDivider'
import AppPDFViewer from '@/components/AppPDFViewer'
import AppLabel from '@/components/AppLabel'
import AppNumber from '@/components/AppNumber'
import AppMemorialDescritivo from './components/AppMemorialDescritivo'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import FileHelper from '@/utils/fileHelper'
import AppOpcoesHeaderAnalise from './components/AppOpcoesHeaderAnalise'
import AppRadiosTramitacao from '@/components/AppRadiosTramitacao'
import AppDoubleInput from '@/components/AppDoubleInput'
import AppCollapse from '@/components/AppCollapse'
import AppCollapseChild from '@/components/AppCollapseChild'
import utils from '@/utils/utils'

export default {
  components: {
    AppDivider,
    AppLabel,
    AppMemorialDescritivo,
    AppNumber,
    FileHelper,
    AppPdfViewer: AppPDFViewer,
    AppOpcoesHeaderAnalise,
    AppRadiosTramitacao,
    AppDoubleInput,
    AppCollapse,
    AppCollapseChild
  },

  mixins: [
    AppNotificacao
  ],

  props: {
    idProcesso: {
      required: true
    },
    visualizarCertidao: {
      required: true
    },
    protocolo: {
      required: false
    }
  },

  data () {
    return {
      processo: {
        numeroProcesso: null,
        numeroProtocolo: null
      },
      infoCertidao: {
        id: null,
        certidao: {
          titulo: {
            numero: null,
            dataEmissao: null,
            numeroProcesso: null
          },
          outorgados: [
            {
              nome: null,
              rg: null,
              orgaoExpedidor: null,
              uf: null,
              cpfCnpj: null
            }
          ],
          imovel: {
            municipio: null,
            denominacao: null,
            perimetro: null,
            area: null
          },
          pagamentos: [
            {
              descricao: null,
              numero: null,
              valor: null,
              dataPagamento: null,
              banco: null
            }
          ]
        },
        usuarioId: null,
        data: null
      },
      numeroProcesso: '',
      active: null,
      bytes: null,
      radios: []
    }
  },

  async created () {
    this.infoCertidao = await this.getInfoCertidaoQuitacao(this.idProcesso)
    this.radios = await this.tarefa({ processo: this.idProcesso })
    this.radios = this.radios.acoes
    this.municipios = await this.findMunicipiosByEstadoAtual()
    this.numeroProcesso = this.idProcesso
    this.processo = await this.getProcessoById(this.idProcesso)
    this.bytes = this.visualizarCertidao ? await this.getCertidaoQuitacaoGerada(this.idProcesso) : null
    this.active = this.visualizarCertidao ? 1 : 0
  },

  methods: {
    ...mapActions({
      tarefa: 'processo/tarefa',
      findMunicipiosByEstadoAtual: 'municipios/findMunicipiosByEstadoAtual',
      getInfoCertidaoQuitacao: 'vtn/getInfoCertidaoQuitacao',
      enviaDadosCertidaoQuitacao: 'vtn/enviaDadosCertidaoQuitacao',
      getCertidaoQuitacaoView: 'vtn/getCertidaoQuitacaoView',
      gerarCertidaoQuitacao: 'vtn/gerarCertidaoQuitacao',
      getCertidaoQuitacaoGerada: 'vtn/getCertidaoQuitacaoGerada',
      getProcessoById: 'processo/getProcessoById'
    }),
    changeMemorial (memorial) {
      this.portaria.memorialDescritivo = memorial
    },

    downloadPdf () {
      FileHelper.saveFile(this.bytes, 'certidão de quitação')
    },

    changeLimites (limites) {
      this.quitacao.limites = limites
      this.scrollToElement()
    },

    scrollToElement () {
      const el = this.$el.getElementsByClassName('app-limites')[0]

      if (el) {
        el.scrollIntoView()
      }
    },

    async proximo () {
      await this.enviaDadosCertidaoQuitacao({id: this.idProcesso, dados: this.infoCertidao.certidao}).then(
        async () => {
          await this.getCertidaoQuitacaoView(this.idProcesso).then(
            (bytes) => {
              this.bytes = bytes
              this.active++
            })
        }).catch(error => {
        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERROR,
          error.message
        )
      })
      this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, this.$messages.CERTIDAO_EMITIDA)
    },

    finalizarPortaria () {
      if (!this.visualizarCertidao) {
        this.confirmBox(this.$messages.FINALIZAR_CERTIDAO_QUITACAO_VASIO, this.$messages.TITULO_WARNING,
          async () => {
            await this.gerarCertidaoQuitacao(this.idProcesso)
            this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, this.$messages.FINALIZAR_CERTIDAO_QUITACAO_SUCESSO)
            this.$router.back()
          },
          () => {})
      } else {
        this.$router.back()
      }
    },

    cancelar () {
      this.confirmBox(this.$messages.CANCELAR_EMISSAO_CERTIDAO_QUITACAO, this.$messages.TITULO_WARNING,
        () => {
          this.$router.back()
        },
        () => { })
    },

    voltar () {
      this.active--
    },

    changeRadio (value) {
      this.quitacao.acao = value.acao
    },

    formatDate (data) {
      return utils.formatDate(data, 'DD/MM/YYYY')
    },

    formatValor (dado) {
      return dado.valor ? dado.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : null
    }
  }
}
</script>

<style scoped lang="scss">
.full-width {
  width: -webkit-fill-available;
}

.margin-medium-top {
  margin-top: 20px;
}

.tamanho {
  background: red;
}

.margin {
  margin-top: 5px;
  margin-bottom: 19px;
}

.teste {
  border: solid 1px red;
}

.buttons-memorial {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}

.link {
  cursor: pointer;
  display: flex;
  text-align: center;
  padding-top: 15px;
  color: #424242;
}

.btn {
  padding: 8px;
  margin-top: 1vh;
  margin-bottom: 1vh;
}

.flex-center {
  display: flex;
  justify-content: center;
}

.width {
  width: 150px;
}

.oi {
  display: flex;
}

.buton-help {
  margin-top: -17px;
  color: #424242;
}

.float-left {
  float: left;
}

.container {
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 100%;
}

#pdf {
  height: 550px !important;
}

.right {
  float: right;
}

.margin-top {
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/screens/financeiro/EmissaoCertidaoQuitacao.vue